import React from 'react';
import EmptyImageIcon from '@internal/plugin-components-react/src/assets/icon/EmptyImage';

export const EmptyTableContent = ({
  children,
}) => {
  return (
    React.createElement('div', {
      style: {
        paddingTop: '0',
        paddingBottom: '0',
        textAlign: 'center',
        height: '300px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexFlow: 'column',
      },}
    
      , React.createElement('div', null
        , React.createElement(EmptyImageIcon, {
          style: {
            width: '184px',
            height: '117px',
          },}
        )
      )
      , React.createElement('div', null, children)
    )
  );
};
